import { createSelector } from 'reselect';

const makeGetNotifications = () => {
  return createSelector(
    state => state.entities.notification,
    state => state.list.notifications,
    state => state.notifications.pageStart,
    state => state.notifications.pageLength,
    (notifications, list, pageStart, pageLength) => {
      return list
        .slice(pageStart, pageStart + pageLength)
        .map(notificationId => {
          return notifications[notificationId];
        });
    }
  );
};

export const getNotifications = makeGetNotifications();



// WEBPACK FOOTER //
// ./src/js/selectors/notificationDetail.js